import React, { useRef, useState, useEffect} from "react";
import Calendar from "react-calendar";
import useDetectClick from "@/components/hooks/useDetectClick";
import { IconLibrary, ThriveIcon } from "thrive-components";
import "../../../css/global/DatePicker.scss";


const DatePicker = ({
  selectedCalendarDate,
  setSelectedCalendarDate,
  minCalendarDate,
  hasError,
}) => {
  const [showCal, setShowCal] = useState<boolean>(false);
  const calOpenRef = useRef<boolean>(false);
  const [showDate, setShowDate] = useState<Date>();

  useDetectClick("date-picker-container", (clickedInCal) => {
    if (!clickedInCal && calOpenRef.current) {
      closeCal();
    }
  });
  
  useEffect(() => {
    if (selectedCalendarDate) {
      setShowDate(selectedCalendarDate)
    }
  }, [selectedCalendarDate]);

  useEffect(() => {
    setShowDate(minCalendarDate);
  }, [])

  function closeCal() {
    setShowCal(false);
    calOpenRef.current = false
  }

  function onDateClick(date: Date) {
    setShowDate(date);
    setSelectedCalendarDate(date);
    closeCal()
  }

  useEffect(()=> {
    if (hasError){
      setShowCal(true);
    } else {
      closeCal()
    }
  }, [selectedCalendarDate, hasError])

  function formatString(date: Date) {
    return Intl.DateTimeFormat(undefined, {
      year: "numeric",
      month: "2-digit",
      day: "2-digit",
    }).format(date);
  }

  return (
    <>
      <div className="date-picker-container">
        <div className="input date-picker">
          <input
            title="date-picker"
            aria-label="Select Date"
            id="date"
            readOnly={true}
            className={`
            ${hasError ? `date-error` : ``} 
            input-field`}
            value={formatString(showDate)}
            type="text"
            onClick={() => {setShowCal(true); calOpenRef.current = true}}
          ></input>

          <ThriveIcon 
            className="calander-icon"
            iconName={IconLibrary.CALENDAR}
            sizeInPx="16"
            color="var(--thriveGreyDark)"
          />
        </div>
        {showCal && (
          <div className="date-picker-mini-calendar" title="react-calendar">
            <Calendar
              defaultActiveStartDate={minCalendarDate}
              onClickDay={onDateClick}
              showWeekNumbers={false}
              showNeighboringMonth={true}
              selectRange={false}
              maxDetail="month"
              minDetail="month"
            />
          </div>
        )}
      </div>
    </>
  );
};

export default DatePicker;
